import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c159cb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item_bar" }
const _hoisted_2 = { class: "bar_container" }
const _hoisted_3 = { class: "bar_img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "bar_meta" }
const _hoisted_6 = { class: "bar_tab_tbody" }
const _hoisted_7 = { class: "bar_tab" }
const _hoisted_8 = { class: "bar_meta_title" }
const _hoisted_9 = { class: "bar_tab_caption" }
const _hoisted_10 = { class: "bar_meta_tbody_wrap" }
const _hoisted_11 = { class: "bar_meta_tbody_desc" }
const _hoisted_12 = { class: "bmtd_text" }
const _hoisted_13 = { class: "bmtd_text_color_high" }
const _hoisted_14 = { class: "bmtd_text" }
const _hoisted_15 = { class: "bmtd_text_color_high" }
const _hoisted_16 = { class: "bar_menu_wrap" }
const _hoisted_17 = { class: "bar_menu" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一键复制", -1))
const _hoisted_19 = {
  key: 0,
  class: "popover"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_27 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "popover"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全局：", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、多频道引导页", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、微信分享", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "子直播间:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_41 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 2,
  class: "popover"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全局：", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、全局注册表单", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "子直播间:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_53 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "一键复制", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "基础设置", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "页面配置", -1))
const _hoisted_57 = ["src"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "观看直播", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "营销互动", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "数据统计", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "发起直播", -1))
const _hoisted_62 = { class: "bar_wrap_tab" }
const _hoisted_63 = { class: "item_select_arrow" }

import { computed, defineAsyncComponent, reactive, withDefaults, ref, createVNode } from 'vue';
import { message, Popover, Tooltip, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useDebounce } from '@/hooks/useDebounce';
import http from '@/api';

// `qrcode` will be a ref of data URL
import type { RootLive } from '@/store/modules/live/types';
import AppLink from '@/components/AppLink.vue';
import { useHomeStore } from '@/pinia/home';
interface IProps {
  dataSource: RootLive;
  choice?: boolean;
  selected?: boolean;
  QRCode?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveItemBar',
  props: {
    dataSource: null,
    choice: { type: Boolean },
    selected: { type: Boolean },
    QRCode: { type: Boolean, default: false }
  },
  emits: ['select:changeItemMark', 'click:showLoading'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: RootLive, choice?: boolean, selected?: boolean, QRCode: boolean };

const aPopover = Popover;
const LiveTab = defineAsyncComponent(() => import('./LiveTab.vue'));
const aTooltip = Tooltip;

const homeStore = useHomeStore();

const isShowQRCode = computed(() => (props.QRCode ? 'home_item' : ''));
const data = reactive(props.dataSource);
const isSelect = computed(() => (props.choice ? 'item_select' : ''));
const isSelected = computed(() => (props.selected ? 'item_selected' : ''));

const setItemSelect = () => {
  if (props.choice) {
    emit('select:changeItemMark', data);
  }
};

const getStudioId = computed(() => {
  if (data.mode === 4 || data.mode === 5) {
    if (data.stream_list && data.mode === 4) {
      return data.stream_list[0].id;
    } else if (data.language_list && data.mode === 5) {
      return data.language_list[0].id;
    } else {
      return data.id;
    }
  }
  return data.id;
});
const getControlId = computed(() => {
  if (data.stream_list && data.mode === 4) {
    return data.stream_list[0].id;
  }
  return data.id;
});

const qrcode = useQRCode(data.qr_code_url, {
  margin: 0,
});

const newStudioId = ref();
const copyChange = useDebounce(() => {
  Modal.confirm({
    content: '此操作将复制直播间的配置，是否继续？',
    centered: true,
    icon: () => createVNode(ExclamationCircleOutlined),
    onOk() {
      emit('click:showLoading', false);
      http.live
        .clickCopy({ studio_id: data.id })
        .then((res) => {
          newStudioId.value = res.data.data;
          message.success(res.data.message);
          window.open(`/live_set/${newStudioId.value}/broad_cast_control`);
        })
        .catch((err) => {
          message.error(err.data.error);
        })
        .finally(() => {
          emit('click:showLoading', true);
        });
    },
  });
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bar_wrap", [_unref(isShowQRCode), _unref(isSelect), _unref(isSelected)]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setItemSelect()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "container_img",
            src: data.image_player_cover_url,
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(LiveTab), {
                tabType: "mode",
                statusType: data.mode,
                playing: data.live_url_status,
                size: "sm"
              }, null, 8, ["statusType", "playing"])
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(data.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, _toDisplayString(data.start_at), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(" 观看量："),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(data.number), 1),
                  _createTextVNode("次 ")
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(" 直播总时长："),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(data.push_stream_duration), 1),
                  _createTextVNode("分钟 ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(aTooltip), null, {
                  title: _withCtx(() => [
                    _hoisted_18,
                    (data.mode === 0 || data.mode === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_27))
                      : _createCommentVNode("", true),
                    (data.mode === 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_41))
                      : _createCommentVNode("", true),
                    (data.mode === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_53))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: _withModifiers(_unref(copyChange), ["stop"]),
                      class: "menu_item"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          "icon-class": "copy_abbreviation",
                          class: "mod_btn_icon"
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(AppLink, {
                  to: `/live_set/${data.id}/broad_cast_control`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTooltip), { title: "基础设置" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "settings"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_55
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(AppLink, {
                  to: `/pages_editor/${_unref(getStudioId)}/page_director`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTooltip), { title: "页面配置" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "brush"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_56
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(AppLink, {
                  to: data.qr_code_url,
                  target: "_block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aPopover), {
                      trigger: props.QRCode ? 'hover' : 'contextmenu'
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(qrcode),
                          class: "qr_img",
                          alt: "QR Code"
                        }, null, 8, _hoisted_57)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "tab_type_play"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["trigger"])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(AppLink, {
                  to: `/market/${_unref(getStudioId)}/mutually_engage`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTooltip), { title: "营销互动" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "present"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_59
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(AppLink, {
                  to: `/data_center/${_unref(getStudioId)}/${_unref(homeStore).funcData['LiveData'] ? 'live' : 'questionnaire'}`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTooltip), { title: "数据统计" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "browser"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_60
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(AppLink, {
                  to: `/console/${_unref(getControlId)}`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTooltip), { title: "发起直播" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "menu_item"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_btn_icon",
                              "icon-class": "control"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_61
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_unref(LiveTab), {
            tabType: "status",
            statusType: data.status,
            size: "sm"
          }, null, 8, ["statusType"])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createVNode(_component_svg_icon, {
          class: "item_select_arrow_icon",
          "icon-class": "checked"
        })
      ])
    ], 2)
  ]))
}
}

})